module.exports = __webpack_public_path__ + "img/FacturaIcon.89b7e57c.svg";